var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.task)?_c('div',{domProps:{"innerHTML":_vm._s(require(("./assets/svg/" + _vm.name + ".svg")))}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.createSvg())}})}
var staticRenderFns = []

export { render, staticRenderFns }